import React from "react"
import { Form } from "semantic-ui-react"

class SelectThesiEuthinis extends React.PureComponent {
  render() {
    const {
      label,
      name,
      value,
      options,
      exclude,
      onChange,
      disabled
    } = this.props

    const filteredOptions = options.filter(
      (obj) => obj.value !== exclude[0] && obj.value !== exclude[1]
    )

    return (
      <Form.Field>
        <label>{label}</label>
        <Form.Group inline>
          <Form.Select
            name={name}
            options={filteredOptions}
            value={value}
            onChange={(e, data) => onChange(name, data.value)}
            placeholder="Επιλέξτε θέση "
            selectOnBlur={false}
            disabled={disabled}
          />
          {value ? (
            <Form.Button icon="undo" onClick={() => onChange(name, null)} />
          ) : null}
        </Form.Group>
      </Form.Field>
    )
  }
}

export default SelectThesiEuthinis
